import { motion } from 'framer-motion'
// import React, { forwardRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import { mediaMax } from '../../../constants/breakpoints'

// import { isFirefox } from '../../../utils/isBrowser'

// interface ScrollerProps {
//   className?: string
//   style?: React.CSSProperties
//   children?: React.ReactNode
// }

// export const Scroller = forwardRef<HTMLDivElement, ScrollerProps>(({ className, style, children }, ref) => {
//   const [browserSupport, setBrowserSupport] = useState(true)

//   useEffect(() => {
//     if (isFirefox) {
//       setBrowserSupport(false)
//     }
//   }, [])

//   const final_className = `${className} ${!browserSupport ? 'browserFix' : ''}`
//   return (
//     <StyledScroller ref={ref} style={style} className={final_className}>
//       {children}
//     </StyledScroller>
//   )
// })
// Scroller.displayName = 'room-scroller'

export const Scroller = styled(motion.div)`
  height: 100%;
  transform-style: preserve-3d;
  pointer-events: none;

  &.browserFix {
    height: auto;
  }
`

export const StillScroller = styled.div`
  height: 100%;
  transform-style: preserve-3d;
  pointer-events: none;
  
  &.browserFix {
    height: auto;
  }
`

export default Scroller
